import EmailReader from '@admin/components/email_reader'
import Panel from '@admin/components/panel'
import React from 'react'

const getEmailReader = (email_campaign) => ({
  endpoint: `/api/admin/campaigns/email/${email_campaign.id}/replies`,
  perspective: 'incoming',
  show_interactions: false,
  show_outcome: true
})

const mapPropsToPanel = (props, context) => ({
  title: 't(Replies)',
  component: <EmailReader { ...getEmailReader(props.email_campaign) } />
})

export default Panel(null, mapPropsToPanel)
